<template>
  <div class="page-panel">
    <div class="page-panel__header">
      <div class="page-panel-header__control">
        <el-button class="page-panel-header-control-button" size="mini" type="primary">返回</el-button>
      </div>
      <div class="page-panel-header__title">平台数据中心</div>
    </div>
    <div class="page-panel__body">
      <stackingChart></stackingChart>
    </div>
    <div class="page-panel__body">
      <columnarChart></columnarChart>
    </div>
  </div>
</template>
<script>
// import * as dataCenterApi from '@/api/dataCenter';
export default {
  data() {
    return {
    };
  },
  methods: {
    // get
  },
  created() {
  }
};
</script>



// WEBPACK FOOTER //
// src/pages/adminPage/dataCenter/index.vue